module.exports = __webpack_public_path__ + "static/media/favicon.26bbeae4.ico";